import React from 'react';
import ButtonBase from './ButtonBase';
import PropTypes from 'prop-types';

const Outline = ({
  type = 'button',
  onClick,
  children,
  disabled,
  size,
  loading,
  iconStart,
  iconEnd,
  tag,
  href,
  download,
  target,
  alt,
}) => {
  return (
    <ButtonBase
      type={type}
      onClick={onClick}
      disabled={disabled}
      size={size}
      loading={loading}
      iconStart={iconStart}
      iconEnd={iconEnd}
      backgroundColor="transparent"
      borderColor="purple"
      color="purple"
      tag={tag}
      href={href}
      download={download}
      target={target}
      alt={alt}
      hover={{
        backgroundColor: 'purple',
        color: 'white',
      }}
    >
      {children}
    </ButtonBase>
  );
};

Outline.propTypes = {
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  size: PropTypes.string,
  loading: PropTypes.bool,
  iconStart: PropTypes.node,
  iconEnd: PropTypes.node,
  tag: PropTypes.string,
  href: PropTypes.string,
  download: PropTypes.bool,
  target: PropTypes.string,
  alt: PropTypes.string,
};

export default Outline;
